import * as angular from 'angular';

class LngPriceUnitComponentCtrl implements ng.IController {
    public unit: StorageBiddingPriceUnitDto;
    public componentDisabled: boolean;
}

angular.module('app').component('pkpLngPriceUnit', {
    controller: LngPriceUnitComponentCtrl,
    template: require('app/lng-offer/lng-price-unit.component.html'),
    bindings: {
        componentDisabled: '<',
        unit: '<'
    }
});
